/**
 * Hairline resize handle for Continuity secondary preview panes.
 * Visual: 1px border (matches app hairlines). Hit target: expanded via inset.
 * Hover: primary wash + cursor-col-resize. Do not use fat `w-1` gutters.
 */

import { PanelResizeHandle } from 'react-resizable-panels'
import { cn } from '@/lib/utils'

/** Prefer this class when composing a custom handle; otherwise use the component. */
export const SECONDARY_PREVIEW_RESIZE_HANDLE_CLASS =
  'relative w-px shrink-0 cursor-col-resize bg-border transition-colors hover:bg-primary focus-visible:bg-primary'

export interface SecondaryPreviewResizeHandleProps {
  className?: string
  disabled?: boolean
  'data-testid'?: string
}

export function SecondaryPreviewResizeHandle({
  className,
  disabled,
  'data-testid': testId,
}: SecondaryPreviewResizeHandleProps) {
  return (
    <PanelResizeHandle
      disabled={disabled}
      data-testid={testId}
      aria-label="Resize preview"
      className={cn(SECONDARY_PREVIEW_RESIZE_HANDLE_CLASS, className)}
    >
      {/* Invisible hit pad - keeps grab easy without a fat default border */}
      <span aria-hidden className="absolute inset-y-0 -left-1.5 -right-1.5" />
    </PanelResizeHandle>
  )
}
